export class Logger {
    /**
     * the log function.
     * @param value the string value to log.
     * @param prefix the prefix to log.
     */
    public static log(value: string, prefix = 'Main thread') {
        console.log(`${prefix} - ${value}`);
    }

    /**
     * the error function.
     * @param value the string value to log.
     * @param prefix the prefix to log.
     */
    public static error(value: string, prefix = 'Angular15UpgradeError') {
        console.log(`${prefix} - ${value}`);
    }
}
